import _ from 'lodash';
import { surveyRequestPayload, surveyVehiclePayload } from '../payloadsStruture';
import { getCompanyDataToInitialValue } from './company';

export const setupSurveyPayload = ({ values, requestJsonData, vehicles }) => {
  const valuesCopy = { ...values };
  if (requestJsonData) {
    if (requestJsonData.cdTipoEmpresa) {
      valuesCopy.cdTipoEmpresa = requestJsonData.cdTipoEmpresa;
    }
    if (requestJsonData.deCpfCnpj) {
      valuesCopy.deCpfCnpj = requestJsonData.deCpfCnpj;
    }
    if (requestJsonData.nmCompleto) {
      valuesCopy.nmCompleto = requestJsonData.nmCompleto;
    }
  }
  valuesCopy.vistoriaVeiculos = vehicles.map(v => {
    let temp = { ...surveyVehiclePayload };
    const found = _.find(valuesCopy.vistoriaVeiculos, o => {
      return o.veiculo.cdVeiculo === v.cdVeiculo;
    });
    if(found) temp = { ...temp, ...found };
    temp.cdVeiculo = v.cdVeiculo;
    temp.veiculo = v;
    temp.documentos = v.documentos || [];
    return temp;
  });
  return valuesCopy;
};

export const setupSurveyInitialValues = (internalNewRequest) => {
  let tempValues = { ...surveyRequestPayload, ...getCompanyDataToInitialValue(internalNewRequest) };
  return tempValues;
}
